import { Card, CardContent, CardMedia, Box, Typography } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import { useUrlParams } from "hooks/useUrlParams";
import { getRemainingTime } from "utils/time";

function MyPageCard({ userEpisode, soulName, displayRelationship = false }) {
  const { contentWork } = useUrlParams();
  const { t } = useTranslation([contentWork]);
  const { days, hours, minutes, isUnderOneHour, isExpired } = getRemainingTime(userEpisode.expire_at);
  return (
    <Card
      sx={(theme) => ({
        position: "relative",
        borderRadius: 2,
        boxShadow: 3,
        width: "100%",
        ...theme.components.myPageCard.paper,
      })}
    >
      {/* アイキャッチ画像 */}
      <CardMedia
        component="img"
        sx={(theme) => ({
          width: "100%",
          maxHeight: 220,
          minHeight: 140,
          objectFit: "cover",
          ...theme.components.myPageCard.media,
        })}
        image={userEpisode.eye_catch_url}
        alt="Image description"
      />

      <CardContent>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            ml: 3,
            mr: 3,
          }}
        >
          {/* キャラクター名 */}
          <Typography
            sx={(theme) => ({
              mr: 2,
              ...theme.components.myPageCard.text.name,
            })}
          >
            {userEpisode.name}
          </Typography>

          {/* 残り日数 */}
          <Box sx={{ mb: 1 }}>
            <Typography
              sx={(theme) => ({
                ...theme.components.myPageCard.text.remainingDays,
              })}
            >
              {isExpired ? (
                <Trans
                  i18nKey="common:remaining_expired"
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={(theme) => ({
                          display: "inline",
                          ...theme.components.myPageCard.text.remainingDays,
                          fontSize: "18px",
                          ...theme.components.myPageCard.text.remainingDaysStrong,
                        })}
                      />
                    ),
                  }}
                />
              ) : isUnderOneHour ? (
                <Trans
                  i18nKey="common:remaining_minutes"
                  values={{ minutes }}
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={(theme) => ({
                          display: "inline",
                          ...theme.components.myPageCard.text.remainingDays,
                          fontSize: "18px",
                          ...theme.components.myPageCard.text.remainingDaysStrong,
                        })}
                      />
                    ),
                  }}
                />
              ) : (
                <Trans
                  i18nKey="common:remaining_days"
                  values={{ days, hours }}
                  components={{
                    strong: (
                      <Typography
                        component="span"
                        sx={(theme) => ({
                          display: "inline",
                          ...theme.components.myPageCard.text.remainingDays,
                          fontSize: "18px",
                          ...theme.components.myPageCard.text.remainingDaysStrong,
                        })}
                      />
                    ),
                  }}
                />
              )}
            </Typography>
          </Box>
        </Box>
        <Typography
          variant="body2"
          sx={(theme) => ({
            whiteSpace: "pre-line",
            lineHeight: 1.6,
            margin: 3,
            ...theme.components.myPageCard.text.description,
            // fontSize: theme.components.myPageCard.description.fontSize,
            // fontFamily: theme.components.myPageCard.description.fontFamily,
            // color: theme.typography.color.primary,
          })} // 下のマージンを追加
        >
          {userEpisode.description}
          {displayRelationship && (
            <>
              {"\n\n"}
              {t(
                `${contentWork}:relationship:${soulName}:${userEpisode.relationship_level}`
              )}
            </>
          )}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default MyPageCard;
